import { LegalLayout, COMPANY } from './LegalPage';

export default function CookiesPage() {
  return (
    <LegalLayout title="Política de Cookies" active="cookies">
      <section>
        <h2>1. ¿Qué son las cookies?</h2>
        <p>Las cookies son pequeños archivos de texto que los sitios web almacenan en el navegador del Usuario cuando este los visita. Permiten que el sitio recuerde información sobre la visita (como preferencias de idioma o sesión iniciada) para que la siguiente visita sea más fácil y el sitio resulte más útil.</p>
      </section>

      <section>
        <h2>2. Cookies utilizadas en este sitio</h2>
        <p>A continuación se detallan las cookies empleadas por <strong>sera.ecommsystem.net</strong>:</p>

        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#d4d4d8', margin: '20px 0 8px' }}>2.1 Cookies estrictamente necesarias</h3>
        <p>Son imprescindibles para el funcionamiento del servicio. Sin ellas no es posible autenticar al Usuario ni mantener la sesión activa. No requieren consentimiento previo (art. 22.2 LSSI).</p>
        <table>
          <tbody>
            <tr>
              <td style={{ width: 160 }}>Proveedor</td>
              <td>Nombre / prefijo</td>
              <td>Finalidad</td>
              <td>Duración</td>
            </tr>
            <tr>
              <td>Clerk</td>
              <td><code>__clerk_*</code>, <code>__session</code></td>
              <td>Gestión de sesión autenticada y seguridad de la cuenta.</td>
              <td>Sesión / hasta 30 días</td>
            </tr>
            <tr>
              <td>Sera AI (propias)</td>
              <td><code>sera_*</code></td>
              <td>Preferencias de interfaz, tema y configuración del widget.</td>
              <td>1 año</td>
            </tr>
          </tbody>
        </table>

        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#d4d4d8', margin: '20px 0 8px' }}>2.2 Cookies analíticas (requieren consentimiento)</h3>
        <p>Permiten medir el uso del Sitio de forma agregada y mejorar la experiencia de Usuario. Solo se activan si el Usuario acepta esta categoría.</p>
        <table>
          <tbody>
            <tr>
              <td style={{ width: 160 }}>Proveedor</td>
              <td>Nombre / prefijo</td>
              <td>Finalidad</td>
              <td>Duración</td>
            </tr>
            <tr>
              <td>Google Analytics</td>
              <td><code>_ga</code>, <code>_gid</code>, <code>_gat</code></td>
              <td>Medición de visitas, páginas vistas y comportamiento agregado de usuarios. Los datos se anonimizan antes de enviarse a Google.</td>
              <td>Hasta 2 años</td>
            </tr>
          </tbody>
        </table>

        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#d4d4d8', margin: '20px 0 8px' }}>2.3 Cookies de terceros vinculadas a pagos (requieren consentimiento)</h3>
        <table>
          <tbody>
            <tr>
              <td style={{ width: 160 }}>Proveedor</td>
              <td>Nombre / prefijo</td>
              <td>Finalidad</td>
              <td>Duración</td>
            </tr>
            <tr>
              <td>Stripe</td>
              <td><code>__stripe_*</code>, <code>_stripe_*</code></td>
              <td>Prevención de fraude y procesamiento seguro de pagos en la página de facturación.</td>
              <td>Sesión / hasta 2 años</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>3. Transferencias internacionales</h2>
        <p>Algunos de los proveedores anteriores (Clerk, Google, Stripe) procesan datos en Estados Unidos. Dichos proveedores están certificados bajo el <strong>Marco de Privacidad de Datos UE-EE. UU. (DPF)</strong> o disponen de cláusulas contractuales tipo aprobadas por la Comisión Europea, lo que garantiza un nivel de protección adecuado.</p>
      </section>

      <section>
        <h2>4. Cómo gestionar o rechazar las cookies</h2>
        <p>El Usuario puede configurar su navegador para bloquear o eliminar cookies. A continuación se incluyen los enlaces a las instrucciones de los navegadores más habituales:</p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
          <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
          <li><a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
        </ul>
        <p>Tenga en cuenta que deshabilitar determinadas cookies puede afectar al funcionamiento del Sitio o impedir el acceso a algunas funcionalidades.</p>
        <p>Para las cookies analíticas de Google Analytics, puede instalar el <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">complemento de inhabilitación de Google Analytics</a>.</p>
      </section>

      <section>
        <h2>5. Base jurídica</h2>
        <p>El uso de cookies estrictamente necesarias se basa en el interés legítimo del titular del Sitio para garantizar el correcto funcionamiento del servicio (art. 6.1.f RGPD y art. 22.2 LSSI). El resto de cookies (analíticas y de terceros) se instalan únicamente previo <strong>consentimiento expreso</strong> del Usuario (art. 6.1.a RGPD y art. 22.2 LSSI).</p>
        <p>El consentimiento puede retirarse en cualquier momento sin que ello afecte a su licitud previa, dirigiéndose a <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.</p>
      </section>

      <section>
        <h2>6. Contacto</h2>
        <p>Para cualquier consulta relacionada con el uso de cookies en este Sitio, puede contactar con {COMPANY.name} en la dirección de correo <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> o en {COMPANY.address}.</p>
        <p><em>Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</em></p>
      </section>
    </LegalLayout>
  );
}
